module.exports = __webpack_public_path__ + "static/media/JY.d84f2607.jpeg";